<button class="search-btn" (click)="openSearchModal()">
  <app-icon [icon]="icons.magnify"></app-icon>
</button>
